import { render } from "./BoxListingCanvas.vue?vue&type=template&id=9375502e"
import script from "./BoxListingCanvas.vue?vue&type=script&lang=js"
export * from "./BoxListingCanvas.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__